import type { ReactNode, HTMLAttributes } from 'react';
import styles from './TableRow.module.css';

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  children: ReactNode;
  isExpanded?: boolean;
  onToggle?: () => void;
}

export function TableRow({
  children,
  isExpanded = false,
  onToggle,
  className,
  ...props
}: TableRowProps) {
  const classes = [
    styles.row,
    isExpanded && styles.expanded,
    className,
  ].filter(Boolean).join(' ');

  return (
    <tr className={classes} {...props}>
      {children}
    </tr>
  );
}

TableRow.displayName = 'TableRow';
